import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend, { RequestCallback } from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import { loadLocaleBundle } from './loadLocale';
import { LocaleCode } from '../constants/localization';

const backendOptions = {
    loadPath: '{{lng}}',
    request: (
        options: any,
        url: string, // will be passed the value of 'loadPath'
        payload: string,
        callback: RequestCallback,
    ) => {
        const lng = url;
        loadLocaleBundle(lng as LocaleCode)
            .then((data: any) => {
                callback(null, {
                    data: JSON.stringify(data),
                    status: 200,
                });
            })
            .catch((e: any) => {
                console.error(e);
                callback(null, {
                    data: e.toString(),
                    status: 500,
                });
            });
    },
};

export const initLang = (local: LocaleCode): void => {
    i18n.use(LanguageDetector)
        .use(Backend)
        .use(initReactI18next) // passes i18n down to react-i18next
        .init({
            backend: backendOptions,
            fallbackLng: local,
            lowerCaseLng: false,
            load: 'currentOnly',
            debug: false, // Enable when debugging
            react: {
                useSuspense: false,
            },
            interpolation: {
                escapeValue: false, // not needed for react as it escapes by default
            },
            detection: {
                // order and from where user language should be detected
                order: ['navigator'],
            },
            saveMissing: false,
            saveMissingTo: 'fallback',
        });
};
